module.exports = __webpack_public_path__ + "static/ROIcalculator2-167079f5a0d3f17577842fca16b55fe5.png";